<template>
  <section class="agenda">
    <div class="agenda__content container">
      <div class="agenda__date">
        <div class="date__container">
          <div>
            <h1 class="date__title">
              Wednesday, Sept 24th
            </h1>
          </div>
          <button class="rotate-btn" v-bind:class="{ 'is-rotated': isRotated, 'iphone-btn': isIphone }"
          @click="seccionVisible = !seccionVisible" v-on:click="toggleRotation">
            <svg :class="{ 'iphone': isIphone }" width="14px" height="9px" viewBox="0 0 18 11">
              <path fill="#3AADCC" d="M9.1,7.8l6.6-6.6C15.8,1.1,16,1,16.1,0.9c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.5,0.1c0.2,0.1,0.3,0.2,0.4,0.3
              s0.2,0.3,0.3,0.4C18,1.8,18,2,18,2.2s0,0.4-0.1,0.5c-0.1,0.2-0.2,0.3-0.3,0.4l-7.5,7.5C9.8,10.8,9.5,11,9.2,11
              c-0.4,0-0.7-0.1-0.9-0.4L0.8,3.1C0.7,3,0.6,2.8,0.5,2.7C0.3,2.5,0.2,2.4,0.2,2.2c0-0.2,0-0.4,0.1-0.5c0.1-0.2,0.2-0.3,0.3-0.4
              S0.9,1.1,1,1c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4,0,0.5,0.1C2.3,1,2.4,1.1,2.5,1.2L9.1,7.8z"/>
            </svg>
          </button>
        </div>
        <hr class="date__line">
      </div>
      <transition name="fade">
        <div v-show="seccionVisible">
          <div class="cards__container">
            <div class="cards__single grayblue">
              <p class="cards__title">
                Doors Open
              </p>
              <div class="cards__description">
                <p>11:30 AM</p>
              </div>
            </div>
            <div class="cards__single gray">
              <p class="cards__title">
                Bit Angels
              </p>
              <div class="cards__description">
                <p>11:30 PM - 12:30 PM</p>
              </div>
            </div>
            <div class="cards__single grayblue">
              <p class="cards__title">
                Lunch
              </p>
              <div class="cards__description">
                <p>12:30 PM - 2:40 PM</p>
              </div>
            </div>
            <div v-for="(speaker, index) in afternoonSet" :key="index" class="cards__single cerulean" :class="speaker.class">
              <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
              <div v-if="speaker.logoClass" :class="'logo-img ' + speaker.logoClass"></div>
              <div v-if="speaker.imgClass" class="circle"></div>
              <div class="cards__speaker">
                <p class="cards__name">{{ speaker.name }}</p>
                <p class="cards__spktitle" v-html="speaker.position"></p>
                <p v-if="speaker.title" class="cards__spktitle" v-html="speaker.title"></p>
              </div>
              <div class="cards__description">
                <p class="time">{{ speaker.time }}</p>
                <p v-if="speaker.location" class="location">{{ speaker.location }}</p>
              </div>
            </div>
          </div>
          <div class="cards__container">
            <div class="cards__single cocktail">
              <p class="cards__title">
                Cocktail Hour
              </p>
              <div class="cards__description">
                <p>7:00 PM - 8:00 PM</p>
              </div>
            </div>
            <div class="cards__single dinner">
              <p class="cards__title">
                Whale Supper Club
              </p>
              <div class="cards__description">
                <p>7:30 PM - 10:00 PM</p>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<style lang="scss">
  @import '@/styles/components/agenda.scss';
</style>

<script>
export default {
  name: 'Day One',
  data() {
    return {
      seccionVisible: true,
      isRotated: false,
      isIphone: false,
      afternoonSet: [
        {
          name: 'DNA Presents: Vision to Venture',
          title: 'Interviewer: Joe Ross - DNA<br>Player1Taco - Manifest Network<br>Katia Zaitsev - Own. App<br>Michal “Mehow” Pospieszalski - MatterFi<br>Bart de Bruijn - EstateX',
          time: '12:50 PM - 1:30 PM',
          class: 'noheight panel'
        },
        {
          name: 'The Future of Capital: Where Institutional Markets Meet Web3',
          title: 'Panel Moderator: Sergey Khusnetdinov<br>Andrey Chabanov - Wellspring<br>Tim Wong - Makina Finance<br>Daryl Lim - TRIVE Digital',
          time: '1:30 PM - 2:00 PM',
          class: 'noheight panel'
        },
        {
          name: 'DNA Presents: Vision to Venture',
          title: 'Interviewer: Joe Ross - DNA<br>Robert Hirsch, Ph.D - Zkalyx<br>Autogames AI',
          time: '2:00 PM - 2:40 PM',
          class: 'noheight panel'
        },
        {
          imgClass: 'y-s',
          name: 'Yat Siu: Endgame or New Beginning? AI and the Future of Gaming',
          title: 'Yat Siu - Animoca Brands<br>Sam Reynolds - CoinDesk',
          time: '3:00 PM - 3:30 PM',
          class: 'noheight special'
        },
        {
          name: 'DNA Presents: Vision to Venture',
          title: 'Interviewer: Joe Ross - DNA<br>Toby Gilbert - Pact Swap<br>Diam Hamstra - Planck',
          time: '3:30 PM - 4:00 PM',
          class: 'noheight panel'
        },
        {
          imgClass: 'a-c',
          name: "DAT's uncovered: Chris Miglino & Ann Chien",
          title: 'Chris Miglino - DNA<br>Ann Chien - IVC',
          time: '4:00 PM - 4:30 PM',
          class: 'noheight special'
        },
        {
          name: 'DAT Treasury Panel: Tokenized Asset Treasuries and Yield Strategies',
          title: 'Panel Moderator: Mark Rydon - Aethir<br>David Gan - Inception Capital<br>Zoriktuev Tamir - CLS Global<br>SJ Oh - Hyper Corporation',
          time: '4:30 PM - 5:00 PM',
          class: 'noheight panel'
        },
        {
          name: 'From Yield to Liquidity: Tokenized Assets in Practice',
          title: 'Moderator: Tokio Nakamoto - Slash Vision Labs<br>Keshav Pandya - Zeebu<br>Noah Thorp - Upside<br>Fahmi Syed - Midnight Foundation<br>Alexander Tkachenko - VNX',
          time: '5:00 PM - 5:30 PM',
          class: 'noheight panel'
        },
        {
          name: 'Regulation and Governance: Building Trust in the Age of Digital Assets',
          title: 'Panel Moderator: Mark Hee - Outlaw<br>Suhhee Han - Barunlaw<br>Michael Ho',
          time: '5:30 PM - 6:00 PM',
          class: 'noheight panel'
        },
        {
          imgClass: 'r-s',
          name: 'Fireside Chat',
          title: 'Roc Zacharias - Lunar Digital Assets<br>Sandeep Nailwal - Polygon',
          time: '6:00 PM - 6:30 PM',
          class: 'noheight special'
        },
        {
          logoClass: 'matterfi',
          name: 'MatterFi Auction',
          title: 'Michal “Mehow” Pospieszalski, CEO & Co-Founder',
          time: '6:30 PM - 7:00 PM',
          class: 'logo'
        },
      ]
    }
  },
  methods: {
    toggleRotation() {
      this.isRotated = !this.isRotated;
    },
  },
  mounted() {
    this.isIphone = /iPhone/.test(navigator.userAgent);
  }
};
</script>
